<div (dndDrop)="onDrop($event, medias)" dndDropzone dndEffectAllowed="all">
    <div dndPlaceholderRef> </div>

    <div *ngFor="let item of medias;let i= index;" [dndDraggable]="item" dndEffectAllowed="all"
        (dndMoved)="onDragged(item, medias)">
        <nz-card class="list-card mt-2">
            <nz-spin [nzSpinning]="isLoading">
                <nz-collapse [nzBordered]="false" class="custom-collapse">
                    <nz-collapse-panel [nzHeader]="title" [(nzActive)]="item.isActive" [nzShowArrow]="false"
                        (nzActiveChange)="onCollapseChange($event, item)">
                        <form #form="ngForm" nz-form (ngSubmit)="form.form.valid">
                            <div nz-col nzSpan="24">
                                <ng-template #title>
                                    <div class="media-item-row">
                                        <div class="media-item-name">
                                            <div class="cursor-move"><img src="./assets/icons/re-order.svg"
                                                    alt="icon" class="mr-2"></div>
                                            <div class="mr-2 cursor-pointer pointer-events-all" nz-tooltip nzTooltipTitle="Preview"
                                                (click)="onPreviewMedia($event, item)"
                                                [ngClass]="{'list-img-wrapper': !item.urlError, 'list-default-wrapper': item.urlError}">
                                                <img *ngIf="!item.urlError" [src]="item.thumbnailUrl || item.iconUrl" alt="list-icon"
                                                    (error)="onMediaUrlError(item)"
                                                    [ngClass]="{'hidden': item.urlError}">
                                            </div>
                                            <div class="text-ellipsis pointer-events-all" nz-tooltip
                                                [nzTooltipTitle]="hideTitleTooltip ? null : item.title">
                                                {{item.title}}</div>
                                        </div>

                                        <div class="staus-container pointer-events-all">
                                            <div class="align-items-center"
                                                *ngIf="item.videoEncodingStatus && item.videoEncodingStatus !== 3">
                                                <div class="d-flex">
                                                    <span nz-icon [nzType]="'loading'" class="icon-primary" nz-tooltip
                                                        nzTooltipTitle="Video optimization in progress. We'll notify you when it's complete."></span>
                                                    &nbsp;<span class="disp-web">Optimizing</span>
                                                </div>
                                            </div>
                                            <div class="align-items-center"
                                                *ngIf="!item.videoEncodingStatus || item.videoEncodingStatus === 3">
                                                <div *ngIf="!item.isActive">
                                                    <div class="d-flex">
                                                        <span nz-icon nzType="check-circle" nzTheme="fill"
                                                            *ngIf="item.status === 1 && !item.isScheduled"
                                                            class="status-icon-success mr-2"></span>
                                                        <span *ngIf="item.status === 1 && !item.isScheduled"
                                                            class="disp-web">Active</span>
                                                    </div>
                                                    <div class="d-flex">
                                                        <span nz-icon nzType="close-circle" nzTheme="fill"
                                                            *ngIf="item.status === 2"
                                                            class="status-icon-danger mr-2"></span>
                                                        <span *ngIf="item.status === 2"
                                                            class="disp-web">In-active</span>
                                                    </div>
                                                    <div class="d-flex">
                                                        <span nz-icon nzType="check-circle" nzTheme="fill"
                                                            *ngIf="item.status === 1 && item.isScheduled"
                                                            class="status-icon-primary mr-2"></span>
                                                        <span *ngIf="item.status === 1 && item.isScheduled"
                                                            class="disp-web">Scheduled</span>
                                                    </div>
                                                    <div class="d-flex">
                                                        <span nz-icon nzType="clock-circle" nzTheme="fill"
                                                            *ngIf="item.status === 4"
                                                            class="status-icon-primary mr-2"></span>
                                                        <span *ngIf="item.status === 4"
                                                            class="disp-web">Scheduled</span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="align-items-center">
                                                <span
                                                    *ngIf="!item.isActive && (!item.videoEncodingStatus || item.videoEncodingStatus === 3)">
                                                    <ng-container *ngIf="item.lengthInSeconds === -1">Full</ng-container>
                                                    <ng-container *ngIf="item.lengthInSeconds !== -1">{{item.lengthInSeconds}}s</ng-container>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="d-d-action-btn">
                                            <div *ngIf="!item.isActive">
                                                <div class="d-flex">
                                                    <ng-container *ngIf="!hideViewEditActions">
                                                        <span nz-icon nzType="eye" nzTheme="outline" class="mr-2 cursor-pointer pointer-events-all"
                                                            nz-tooltip nzTooltipTitle="Preview"
                                                            (click)="onPreviewMedia($event, item)"></span>
                                                        <div class="mr-2 pointer-events-all d-flex align-items-center"
                                                            nz-tooltip nzTooltipTitle="Edit Media"
                                                            (click)="$event.stopPropagation(); onCollapseChange(true, item)">
                                                            <img src="./assets/icons/edit.svg"
                                                                alt="list-icon" class="cursor-pointer filter_darkmode">
                                                        </div>
                                                    </ng-container>
                                                    <span nz-icon nzType="delete" nzTheme="outline"
                                                        (click)="removeMedia(i, item)"
                                                        class="cursor-pointer pointer-events-all"></span>
                                                </div>
                                            </div>
                                            <div *ngIf="item.isActive">
                                                <span nz-icon nzType="check" nzTheme="outline"
                                                    class="mr-3 pointer-events-all"
                                                    (click)="confirmUpdateMedia($event, item)"></span>
                                                <span nz-icon nzType="close" nzTheme="outline"
                                                    class="pointer-events-all" (click)="close($event, item)"></span>
                                            </div>
                                        </div>
                                    </div>
                                </ng-template>
                            </div>

                            <div nz-row [nzGutter]="[16]" class="mt-3 mb-1" *ngIf="isModelLoaded && (item.isPaidAddOn || item.lengthInSeconds === -1)">
                                <div nz-col nzSpan="24">
                                    <label nz-checkbox
                                        [ngModel]="item.lengthInSeconds === -1"
                                        (ngModelChange)="onShowFullContentChange(item, $event)"
                                        [ngModelOptions]="{standalone: true}">
                                        Show full content
                                    </label>
                                </div>
                            </div>
                            <div nz-row [nzGutter]="[16]" class="mb-3" *ngIf="isModelLoaded">
                                <div nz-col nzSpan="12">
                                    <div class="input-container mt-2">
                                        <nz-form-item>
                                            <nz-form-control class="mb-0">
                                                <nz-form-label>Media Status</nz-form-label>
                                                <div class="prefix-select-wrap">
                                                    <i nz-icon nzType="check-circle" nzTheme="fill"
                                                        class="form-field-prefix-icon status-icon-success"
                                                        *ngIf="model.isEnabled"></i>
                                                    <i nz-icon nzType="close-circle" nzTheme="fill"
                                                        class="form-field-prefix-icon status-icon-danger"
                                                        *ngIf="!model.isEnabled"></i>
                                                    <nz-select class="header-input" name="status"
                                                        [(ngModel)]="model.isEnabled">
                                                        <nz-option [nzValue]="true" nzLabel="Enabled"></nz-option>
                                                        <nz-option [nzValue]="false" nzLabel="Hidden"></nz-option>
                                                    </nz-select>
                                                </div>
                                            </nz-form-control>
                                        </nz-form-item>
                                    </div>
                                </div>
                                <div nz-col nzSpan="12">
                                    <div class="input-container mt-2">
                                        <nz-form-item>
                                            <nz-form-control class="mb-0">
                                                <!-- <ng-container *ngIf="item.videoEncodingStatus !== 3">
                                                    <nz-form-label>&nbsp;</nz-form-label>
                                                    <span style="line-height: 32px;">Display time is automatically
                                                        calculated</span>
                                                </ng-container> -->
                                                <ng-container>
                                                    <nz-form-label>Display Time (Seconds)</nz-form-label>
                                                    <nz-input-group>
                                                        <input nz-input placeholder="Enter your display time"
                                                            name="displayTime" #displayTime="ngModel"
                                                            [(ngModel)]="item.lengthInSeconds"
                                                            [disabled]="item.isPaidAddOn && item.lengthInSeconds === -1" />
                                                    </nz-input-group>
                                                    <div *ngIf="form.submitted || displayTime?.touched || displayTime?.dirty"
                                                        class="validation-error-message">
                                                        <span nz-icon nzType="exclamation-circle" nzTheme="fill"
                                                            class="validation-icon mt-1"
                                                            *ngIf="displayTime?.errors"></span>
                                                        <span *ngIf="displayTime?.errors?.['required']" class="ml-1">
                                                            How
                                                            long
                                                            do
                                                            you want
                                                            this media to show on this playlist? You must enter time in
                                                            between
                                                            1 to
                                                            21600 seconds. </span>
                                                    </div>
                                                </ng-container>
                                            </nz-form-control>
                                        </nz-form-item>
                                    </div>
                                </div>
                            </div>
                            <div nz-row [nzGutter]="[16]" class="mt-3 mb-3"
                                *ngIf="isModelLoaded && model.type == constants.mediaAppType.youTube && model.youTube">
                                <div nz-col nzSpan="24">
                                    <label class="static-form-label">YouTube content type</label>
                                    <div class="align-items-center">
                                        <nz-tag nzColor="blue">
                                            <span nz-icon
                                                [nzType]="getYoutubeTypeIcon(model.youTube.type)"
                                                nzTheme="outline" class="mr-1"></span>
                                            {{ getYoutubeTypeLabel(model.youTube.type) }}
                                        </nz-tag>
                                        <span *ngIf="model.youTube.videoTitle"
                                            class="ml-2 fs-12 text-ellipsis"
                                            nz-tooltip [nzTooltipTitle]="model.youTube.videoTitle">
                                            {{ model.youTube.videoTitle }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div nz-row class="mt-2 mb-3" *ngIf="isModelLoaded">
                                <div nz-col nzSpan="24">
                                    <div class="align-items-center">
                                        <label class="mr-3" for="" class="fs-16 mb-0 fw-bold">Schedule</label>
                                        <span class="ml-3"><app-feature-lock featureKey="advanced_media_scheduling"><nz-switch [(ngModel)]="isScheduled" name="schedule"
                                                (ngModelChange)="onSchedule()" #schedule="ngModel"></nz-switch></app-feature-lock></span>
                                    </div>
                                    <div nz-row class="mt-3 mb-3 ml-2" *ngIf="isScheduled">
                                        <div nz-col nzSpan="24">
                                            <nz-radio-group [(ngModel)]="model.isDaily" name="isDaily"
                                                #isDaily="ngModel" (ngModelChange)="scheduleTypeChanged($event)">
                                                <label nz-radio [nzValue]="true">Daily</label>
                                                <label nz-radio [nzValue]="false">Date
                                                    Range</label>
                                            </nz-radio-group>
                                        </div>
                                    </div>

                                    <div nz-row [nzGutter]="[16]" class="mt-2" *ngIf="isScheduled">
                                        <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12">
                                            <div class="input-container mt-2">
                                                <nz-form-item>
                                                    <nz-form-control>
                                                        <nz-form-label> Start Time </nz-form-label>
                                                        <nz-time-picker [nzUse12Hours]="true" [nzAllowEmpty]="false"
                                                            (ngModelChange)="isStartTimeValid($event)"
                                                            class="cursor-pointer" [(ngModel)]="scheduleStartTime"
                                                            name="startTime" #startTime="ngModel" nzFormat="hh:mm a"
                                                            nzPlaceHolder="Select" required>
                                                        </nz-time-picker>
                                                        <div *ngIf="form.submitted || startTime?.touched"
                                                            class="validation-error-message">
                                                            <span nz-icon nzType="exclamation-circle" nzTheme="fill"
                                                                class="validation-icon mt-1"
                                                                *ngIf="startTime?.errors"></span>
                                                            <span *ngIf="startTime?.errors?.['required']"
                                                                class="ml-1">Start
                                                                time is
                                                                required</span>
                                                        </div>
                                                    </nz-form-control>
                                                </nz-form-item>
                                            </div>
                                        </div>
                                        <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12">
                                            <div class="input-container mt-2">
                                                <nz-form-item>
                                                    <nz-form-control>
                                                        <nz-form-label> End Time </nz-form-label>
                                                        <nz-time-picker [nzUse12Hours]="true" class="cursor-pointer"
                                                            (ngModelChange)="isTimeValid($event)" [nzAllowEmpty]="false"
                                                            [(ngModel)]="scheduleEndTime" name="endTime"
                                                            #endTime="ngModel" nzFormat="hh:mm a" nzPlaceHolder="Select"
                                                            required>
                                                        </nz-time-picker>
                                                        <div *ngIf="form.submitted || endTime?.touched"
                                                            class="validation-error-message">
                                                            <span nz-icon nzType="exclamation-circle" nzTheme="fill"
                                                                class="validation-icon mt-1"
                                                                *ngIf="(endTime?.errors) || (!endTime?.errors?.['required'] && !isEndTimeValid)"></span>
                                                            <span *ngIf="endTime?.errors?.['required']" class="ml-1">End
                                                                time is required</span>
                                                            <span
                                                                *ngIf="!endTime?.errors?.['required'] && !isEndTimeValid"
                                                                class="ml-1">Please select any future time</span>
                                                        </div>
                                                    </nz-form-control>
                                                </nz-form-item>
                                            </div>
                                        </div>
                                    </div>

                                    <div nz-row [nzGutter]="[16]" *ngIf="isScheduled && !model.isDaily">
                                        <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12">
                                            <div class="input-container">
                                                <nz-form-item>
                                                    <nz-form-control>
                                                        <nz-form-label> Start Date</nz-form-label>
                                                        <nz-date-picker nzFormat="MM/dd/yyyy" name="startDate"
                                                            [nzAllowClear]="false" [(ngModel)]="model.startDate"
                                                            #startDate="ngModel" [nzDisabledDate]="disableStartDate"
                                                            nzPlaceHolder="Select" required
                                                            class="cursor-pointer"></nz-date-picker>
                                                        <div *ngIf="form.submitted || startDate?.touched"
                                                            class="validation-error-message">
                                                            <span nz-icon nzType="exclamation-circle" nzTheme="fill"
                                                                class="validation-icon mt-1"
                                                                *ngIf="startDate?.errors"></span>
                                                            <span *ngIf="startDate?.errors?.['required']"
                                                                class="ml-1">Start
                                                                date is
                                                                required</span>
                                                        </div>
                                                    </nz-form-control>
                                                </nz-form-item>
                                            </div>
                                        </div>
                                        <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12">
                                            <div class="input-container">
                                                <nz-form-item>
                                                    <nz-form-control>
                                                        <nz-form-label> End Date</nz-form-label>
                                                        <nz-date-picker nzFormat="MM/dd/yyyy" name="endDate"
                                                            [nzAllowClear]="false" [(ngModel)]="model.endDate"
                                                            #endDate="ngModel" [nzDisabledDate]="disableEndDate"
                                                            nzPlaceHolder="Select" required
                                                            class="cursor-pointer"></nz-date-picker>
                                                        <div *ngIf="form.submitted || endDate?.touched"
                                                            class="validation-error-message">
                                                            <span nz-icon nzType="exclamation-circle" nzTheme="fill"
                                                                class="validation-icon mt-1"
                                                                *ngIf="endDate?.errors"></span>
                                                            <span *ngIf="endDate?.errors?.['required']" class="ml-1">End
                                                                date is
                                                                required</span>
                                                        </div>
                                                    </nz-form-control>
                                                </nz-form-item>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </nz-collapse-panel>
                </nz-collapse>
            </nz-spin>
        </nz-card>
    </div>

    <nz-drawer [nzVisible]="showMediaEditDrawer" [nzWidth]="720" [nzClosable]="false" [nzTitle]="null"
        nzPlacement="right" [nzMaskClosable]="true" (nzOnClose)="closeMediaEditDrawer()" class="custom-drawer">
        <ng-container *nzDrawerContent>
            <nz-spin *ngIf="!dynamicAppLoaded" nzSimple></nz-spin>
            <ng-template #dynamicAppHost></ng-template>
        </ng-container>
    </nz-drawer>
</div>